import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-technical-qa',
  templateUrl: './technical-qa.component.html',
  styleUrls: ['./technical-qa.component.css'],
})
export class TechnicalQaComponent {
  url: string = 'seoOffpageCampaigns';

  loading: boolean = true;
  saving: boolean = false;

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // ── Filter state ──────────────────────────────────────────────────────────
  selectedLocation: string = 'miami_fl';
  selectedUniverse: string = 'courier';
  selectedCategory: string = '';
  selectedIssueType: string = '';
  selectedStatus: string = '';
  selectedPriority: string = '';

  pendingLocation: string = 'miami_fl';
  pendingUniverse: string = 'courier';
  pendingCategory: string = '';
  pendingIssueType: string = '';
  pendingStatus: string = '';
  pendingPriority: string = '';

  activeTab: string = 'all';

  // ── Lookup tables ─────────────────────────────────────────────────────────
  locations = [
    { value: 'all', label: 'All Locations' },
    { value: 'orlando_fl', label: 'Orlando, FL' },
    { value: 'tampa_fl', label: 'Tampa, FL' },
    { value: 'naples_fl', label: 'Naples, FL' },
    { value: 'west_palm_beach_fl', label: 'West Palm Beach, FL' },
    { value: 'boca_raton_fl', label: 'Boca Raton, FL' },
    { value: 'miami_fl', label: 'Miami, FL' },
  ];

  universes = [
    { value: 'courier', label: 'Courier' },
    { value: 'runner', label: 'Runner' },
  ];

  categories = [
    { value: 'company_brand', label: 'Company Brand' },
    { value: 'same_day_courier', label: 'Same-Day Courier' },
    { value: 'rush_courier', label: 'Rush Courier' },
    { value: 'legal_services', label: 'Legal Services' },
    { value: 'business_courier', label: 'Business Courier' },
  ];

  issueTypes = [
    { value: '', label: 'All Issues' },
    { value: 'canonical_conflict', label: 'Canonical Conflict' },
    { value: 'meta_noindex', label: 'Meta Noindex' },
    { value: 'not_indexed', label: 'Not Indexed' },
    { value: '404_not_found', label: '404 Not Found' },
    { value: 'sitemap_missing', label: 'Sitemap Missing' },
    { value: 'redirect_chain', label: 'Redirect Chain' },
    { value: 'schema_error', label: 'Schema Error' },
    { value: '5xx_server_error', label: '5xx Server Error' },
  ];

  statuses = [
    { value: '', label: 'All Statuses' },
    { value: 'needs_fix', label: 'Needs Fix' },
    { value: 'queued', label: 'Queued' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'resolved', label: 'Resolved' },
  ];

  priorities = [
    { value: '', label: 'All Priorities' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' },
  ];

  // ── Tabs ──────────────────────────────────────────────────────────────────
  tabs = [
    { key: 'all', label: 'All Issues', count: 156, colorClass: 'text-dark' },
    {
      key: 'critical',
      label: 'Critical',
      count: 23,
      colorClass: 'text-danger',
    },
    {
      key: 'indexation',
      label: 'Indexation',
      count: 28,
      colorClass: 'text-warning',
    },
    {
      key: 'crawlability',
      label: 'Crawlability',
      count: 21,
      colorClass: 'text-info',
    },
    {
      key: 'status_codes',
      label: 'Status Codes',
      count: 14,
      colorClass: 'text-dark',
    },
    {
      key: 'canonicals',
      label: 'Canonicals',
      count: 19,
      colorClass: 'text-primary',
    },
    {
      key: 'sitemaps',
      label: 'Sitemaps',
      count: 12,
      colorClass: 'text-success',
    },
    { key: 'schema', label: 'Schema', count: 18, colorClass: 'text-purple' },
    // {
    //   key: 'performance',
    //   label: 'Performance',
    //   count: 21,
    //   colorClass: 'text-orange',
    // },
  ];

  // ── Loaded data ───────────────────────────────────────────────────────────
  allCampaigns: any[] = [];
  campaign: any = null;
  campaignId: string = '';

  // ── Stats ─────────────────────────────────────────────────────────────────
  stats = {
    urlsAudited: { value: 0, trend: '', up: true },
    issuesDetected: { value: 0, trend: '', up: true },
    criticalIssues: { value: 0, trend: '', up: false },
    pendingFix: { value: 0, trend: '', up: true },
    resolved: { value: 0, trend: '', up: true },
    eligibilityHealth: { value: 0, trend: '', up: true },
  };

  // ── Issues Queue (main table) ─────────────────────────────────────────────
  issuesQueue: any[] = [];

  // ── Selected issue for right panel ────────────────────────────────────────
  selectedIssue: any = {
    issueType: '',
    priority: '',
    url: '',
    urlLabel: '',
    mappedIntent: '',
    issue: '',
    currentStatus: '',
    expected: '',
    impact: '',
    indexationStatus: '',
    httpStatus: '',
    canonicalFound: '',
    discovered: '',
    firstDetected: '',
    lastChecked: '',
    reviewOrigin: '',
    aiRationale: '',
    _index: -1,
  };

  // ── Eligibility Overview ──────────────────────────────────────────────────
  eligibilityOverview = {
    score: 89,
    eligible: { count: 1112, pct: 89 },
    atRisk: { count: 98, pct: 8 },
    ineligible: { count: 38, pct: 3 },
  };

  // ── Issues by Type ────────────────────────────────────────────────────────
  issuesByType: any[] = [];

  // ── Top Pages by Issues ───────────────────────────────────────────────────
  topPagesByIssues: any[] = [];

  // ── Recently Resolved ─────────────────────────────────────────────────────
  recentlyResolved: any[] = [];

  // ── Signals (right panel) ─────────────────────────────────────────────────
  signals: any[] = [];

  // ── Technical Action Center ───────────────────────────────────────────────
  actionCenter = {
    selectedAction: 'Set Self-Referencing Canonical',
    targetUrl: '/legal-services/',
    element: 'Canonical Tag',
    decisionOrigin: 'AI Detected',
    currentCode: `<link rel="canonical"\n  href="https://courierbeyond.com/\n  courier-services/"/>`,
    proposedCode: `<link rel="canonical"\n  href="https://courierbeyond.com/\n  legal-services/"/>`,
    aiRecommendation: `This URL is the assigned Primary URL for the mapped intent. Canonical should be self-referencing to consolidate signals and align with architecture.`,
    aiConfidence: 92,
    riskLevel: 'Medium',
    executionMode: 'Human Approval Required',
  };

  constructor(
    private router: Router,
    private dataService: DataService,
    private messageService: MessageService,
  ) {}

  // ── Lifecycle ─────────────────────────────────────────────────────────────
  ngOnInit(): void {
    this.loadCampaigns();
  }

  // ── Data loading ──────────────────────────────────────────────────────────
  loadCampaigns(): void {
    this.loading = true;
    const params = `?status=approved&limit=200`;

    this.dataService.getData(`${this.url}${params}`).subscribe(
      (response: any) => {
        if (response.rst && response.data) {
          this.allCampaigns = response.data;
          this.applyFilterAndSelect();
        } else {
          this.messageService.add(
            response.msg || 'Error loading campaigns',
            'danger',
          );
          this.loading = false;
          this.buildStaticData();
        }
      },
      (_err: any) => {
        this.messageService.add('Could not connect to the server.', 'danger');
        this.loading = false;
        this.buildStaticData();
      },
    );
  }

  applyFilterAndSelect(): void {
    const matched = this.allCampaigns.filter((c: any) => {
      const locMatch =
        !this.selectedLocation || c.location === this.selectedLocation;
      const uniMatch =
        !this.selectedUniverse || c.universe === this.selectedUniverse;
      const catMatch =
        !this.selectedCategory || c.category === this.selectedCategory;
      return locMatch && uniMatch && catMatch;
    });

    if (matched.length > 0) {
      this.campaign = matched[0];
      this.campaignId = matched[0]._id;
    }

    this.buildStaticData();
    this.loading = false;
  }

  onFilterChange(): void {
    this.selectedLocation = this.pendingLocation;
    this.selectedUniverse = this.pendingUniverse;
    this.selectedCategory = this.pendingCategory;
    this.selectedIssueType = this.pendingIssueType;
    this.selectedStatus = this.pendingStatus;
    this.selectedPriority = this.pendingPriority;

    this.applyFilterAndSelect();
  }

  // ── Build static / demo data ──────────────────────────────────────────────
  buildStaticData(): void {
    this.buildStats();
    this.buildIssuesQueue();
    this.buildIssuesByType();
    this.buildTopPagesByIssues();
    this.buildRecentlyResolved();
    this.buildSignals();
    if (this.issuesQueue.length > 0) {
      this.selectIssue(this.issuesQueue[0]);
    }
  }

  buildStats(): void {
    this.stats = {
      urlsAudited: { value: 1248, trend: '18.2% vs last 30 days', up: true },
      issuesDetected: { value: 156, trend: '6.7% vs last 30 days', up: true },
      criticalIssues: { value: 23, trend: '2 vs last 30 days', up: false },
      pendingFix: { value: 37, trend: '5 vs last 30 days', up: true },
      resolved: { value: 96, trend: '15.5% vs last 30 days', up: true },
      eligibilityHealth: { value: 89, trend: '6% vs last 30 days', up: true },
    };
  }

  buildIssuesQueue(): void {
    this.issuesQueue = [
      {
        url: '/legal-services/',
        primaryIntent: 'Miami Legal Courier',
        issueType: 'Canonical Conflict',
        issueTypeIcon: 'fas fa-exclamation-circle text-danger',
        issueDetails: 'Canonical points to /courier-services/',
        priority: 'High',
        status: 'Needs Fix',
        detected: 'May 18, 2025',
        recommendedAction: 'Review Canonical',
        category: 'canonicals',
      },
      {
        url: '/same-day-courier-miami/',
        primaryIntent: 'Same-Day Courier Miami',
        issueType: 'Meta Noindex',
        issueTypeIcon: 'fas fa-eye-slash text-warning',
        issueDetails: 'Meta robots noindex detected',
        priority: 'High',
        status: 'Needs Fix',
        detected: 'May 18, 2025',
        recommendedAction: 'Remove Noindex',
        category: 'indexation',
      },
      {
        url: '/cities/miami/',
        primaryIntent: 'Courier in Miami',
        issueType: 'Not Indexed',
        issueTypeIcon: 'fas fa-search text-info',
        issueDetails: 'Discovered - currently not indexed',
        priority: 'Medium',
        status: 'Under Review',
        detected: 'May 17, 2025',
        recommendedAction: 'Investigate',
        category: 'indexation',
      },
      {
        url: '/courthouse-delivery/',
        primaryIntent: 'Courthouse Delivery',
        issueType: '404 Not Found',
        issueTypeIcon: 'fas fa-unlink text-danger',
        issueDetails: 'URL returns 404',
        priority: 'High',
        status: 'Needs Fix',
        detected: 'May 17, 2025',
        recommendedAction: 'Set Redirect',
        category: 'status_codes',
      },
      {
        url: '/medical-courier/',
        primaryIntent: 'Medical Courier',
        issueType: 'Sitemap Missing',
        issueTypeIcon: 'fas fa-map text-warning',
        issueDetails: 'URL not found in sitemap',
        priority: 'Medium',
        status: 'Queued',
        detected: 'May 16, 2025',
        recommendedAction: 'Add to Sitemap',
        category: 'sitemaps',
      },
      {
        url: '/routes/miami-to-orlando/',
        primaryIntent: 'Miami to Orlando Courier',
        issueType: 'Redirect Chain',
        issueTypeIcon: 'fas fa-random text-warning',
        issueDetails: '3 redirects in chain',
        priority: 'Medium',
        status: 'Needs Fix',
        detected: 'May 16, 2025',
        recommendedAction: 'Collapse Chain',
        category: 'crawlability',
      },
      {
        url: '/task-runner/',
        primaryIntent: 'Task Runner Services',
        issueType: 'Schema Error',
        issueTypeIcon: 'fas fa-code text-info',
        issueDetails: 'Invalid JSON-LD – missing field',
        priority: 'Medium',
        status: 'Needs Fix',
        detected: 'May 15, 2025',
        recommendedAction: 'Fix Schema',
        category: 'schema',
      },
      {
        url: '/business-accounts/',
        primaryIntent: 'Business Accounts',
        issueType: '5xx Server Error',
        issueTypeIcon: 'fas fa-server text-danger',
        issueDetails: 'URL returns 500',
        priority: 'High',
        status: 'Needs Fix',
        detected: 'May 15, 2025',
        recommendedAction: 'Escalate',
        category: 'status_codes',
      },
    ];
  }

  buildIssuesByType(): void {
    this.issuesByType = [
      { type: 'Indexation', issues: 28, change: +3, changeDir: 'up' },
      {
        type: 'Crawlability & Robots',
        issues: 21,
        change: +2,
        changeDir: 'up',
      },
      { type: 'Status Codes', issues: 14, change: +1, changeDir: 'up' },
      {
        type: 'Canonicals & Redirects',
        issues: 19,
        change: +4,
        changeDir: 'up',
      },
      { type: 'Sitemaps', issues: 12, change: -1, changeDir: 'down' },
      {
        type: 'Schema Implementation',
        issues: 18,
        change: +4,
        changeDir: 'up',
      },
      {
        type: 'Performance & Experience',
        issues: 21,
        change: +3,
        changeDir: 'up',
      },
    ];
  }

  buildTopPagesByIssues(): void {
    this.topPagesByIssues = [
      { url: '/legal-services/', issues: 3, severity: 'High' },
      { url: '/same-day-courier-miami/', issues: 2, severity: 'High' },
      { url: '/courthouse-delivery/', issues: 2, severity: 'High' },
      { url: '/cities/miami/', issues: 2, severity: 'Medium' },
      { url: '/routes/miami-to-orlando/', issues: 2, severity: 'Medium' },
    ];
  }

  buildRecentlyResolved(): void {
    this.recentlyResolved = [
      { issue: 'Sitemap Missing', url: '/about-us/', resolved: 'May 19' },
      { issue: 'Meta Noindex', url: '/blog/legal-guide/', resolved: 'May 18' },
      {
        issue: 'Canonical Conflict',
        url: '/courier-services/',
        resolved: 'May 17',
      },
      { issue: 'Redirect Chain', url: '/services/', resolved: 'May 17' },
      { issue: '404 Not Found', url: '/old-page/', resolved: 'May 16' },
    ];
  }

  buildSignals(): void {
    this.signals = [
      {
        signal: 'Mapping Review Recommended',
        to: 'URL Mapping',
        status: 'Sent',
        date: 'May 18',
      },
      {
        signal: 'Internal Support Needed',
        to: 'Internal Links',
        status: 'Open',
        date: 'May 18',
      },
      {
        signal: 'Canonical Conflict Detected',
        to: 'On-Page',
        status: 'Open',
        date: 'May 17',
      },
      {
        signal: 'Indexation Monitoring',
        to: 'Performance',
        status: 'Monitoring',
        date: 'May 18',
      },
    ];
  }

  // ── Tab filtering ─────────────────────────────────────────────────────────
  get filteredIssues(): any[] {
    if (this.activeTab === 'all') return this.issuesQueue;
    return this.issuesQueue.filter((i) => i.category === this.activeTab);
  }

  setTab(key: string): void {
    this.activeTab = key;
  }

  // ── Selection ─────────────────────────────────────────────────────────────
  selectIssue(issue: any): void {
    this.selectedIssue = {
      issueType: issue.issueType || 'Canonical Conflict',
      priority: issue.priority || 'High',
      url: issue.url || '/legal-services/',
      urlLabel: issue.url || '/legal-services/',
      mappedIntent: issue.primaryIntent || 'Miami Legal Courier',
      issue: issue.issueDetails || 'Canonical points to /courier-services/',
      currentStatus: 'Needs Fix',
      expected: 'Self-referencing canonical',
      impact: 'High',
      indexationStatus: 'Indexed',
      httpStatus: '200 OK',
      canonicalFound: '/courier-services/',
      discovered: 'May 18, 2025  10:24 AM',
      firstDetected: 'May 18, 2025  10:24 AM',
      lastChecked: 'May 18, 2025  10:24 AM',
      reviewOrigin: 'URL Mapping Signal',
      aiRationale:
        'This URL is the assigned Primary URL for the intent but its canonical points to a different page. This can cause indexation and ranking dilution.',
      _index: this.issuesQueue.indexOf(issue),
    };
  }

  // ── Actions ───────────────────────────────────────────────────────────────
  approveAction(): void {
    this.messageService.add(
      'Action approved and queued for implementation.',
      'success',
    );
  }

  rejectAction(): void {
    this.messageService.add('Action rejected.', 'info');
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  getStatusClass(status: string): string {
    const map: Record<string, string> = {
      'Needs Fix': 'bg-danger-light text-danger',
      Queued: 'bg-warning-light text-warning',
      'Under Review': 'bg-primary-light text-primary',
      Resolved: 'bg-success-light text-success',
    };
    return map[status] || 'bg-light text-dark';
  }

  getPriorityClass(priority: string): string {
    const map: Record<string, string> = {
      High: 'bg-danger-light text-danger',
      Medium: 'bg-warning-light text-warning',
      Low: 'bg-success-light text-success',
    };
    return map[priority] || 'bg-light text-dark';
  }

  getSeverityClass(severity: string): string {
    const map: Record<string, string> = {
      High: 'badge bg-danger-light text-danger',
      Medium: 'badge bg-warning-light text-warning',
      Low: 'badge bg-success-light text-success',
    };
    return map[severity] || 'badge bg-light text-dark';
  }

  getSignalStatusClass(status: string): string {
    const map: Record<string, string> = {
      Sent: 'bg-success-light text-success',
      Open: 'bg-warning-light text-warning',
      Monitoring: 'bg-primary-light text-primary',
    };
    return map[status] || 'bg-light text-dark';
  }

  goBack(): void {
    this.router.navigateByUrl('marketing');
  }
}
